import axios from 'smg/axios';
import * as hyejoo from 'smg/customer-api/hyejoo';
import * as session from 'smg/customer-api/session';
import { Session } from 'smg/customer-api/session';
import * as taxexemptions from 'smg/customer-api/usertaxexemptions';
import * as models from 'smg/models';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { UUID } from 'smg/uuid';
import { DownloadURLs, Source } from 'smg/zip';
import { PageLoader } from '../account';
import { Relref } from '../hugo';
import { Draw, PromptNew } from '../usertaxexemptions';

declare interface myWindow extends Window {
    readonly cloudFront: string;
}
declare const window: myWindow;

export default async function main() {
    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    const sess = await Session();

    const cardTemplate = document.querySelector('#card') as HTMLTemplateElement;
    const parent = document.querySelector('#taxExemptionsContainer') as HTMLElement;
    const addNewTemplate = document.querySelector('#addNewTemplate') as HTMLElement;
    const addNewButton = document.querySelectorAll('.addNew');

    addNewButton.forEach(el => {
        el.addEventListener('click', () => {
            void PromptNew(sess).then(() => {
                pl.Load();
            });
        });
    });

    const pl: PageLoader<models.UserTaxExemption> = new PageLoader<models.UserTaxExemption>({
        afterLoad: () => {
            parent.append(addNewTemplate);
            addNewTemplate.classList.remove('d-none');
        },
        parent: document.querySelector('#taxExemptionsContainer') as HTMLElement,
        get: () => axios.get<hyejoo.UserTaxExemptions>('/user-tax-exemptions', {
            params: {
                'sort': pl.Sort(),
                'max': pl.CurrentPageSize(),
                // 'data': 'id, userTaxExemptionReasonID, countryID, stateID, number, UserTaxExemptionReason, userTaxExemptionUploads, created',
                'p': pl.CurrentPage(),
                'q': pl.Search(),
            },
        }).then(resp => ({ rows: resp.data.userTaxExemptions, nextPage: resp.data.nextPage })),
        draw: async userTaxExemptions => {
            const card = template.Clone(cardTemplate);
            const deleteBtn = card.querySelector<HTMLButtonElement>('.delete-btn');
            const downloadBtn = card.querySelector<HTMLButtonElement>('.download-btn');

            await Draw(userTaxExemptions, card);

            deleteBtn?.addEventListener('click', () => {
                void taxexemptions.DeleteUserTaxExemption(userTaxExemptions.id || '').
                    then(() => {
                        card.parentElement?.removeChild(card);
                        const undoLinkID = `undo-${UUID()}`;
                        const t = toast.Success(`Removed tax exemption. <a href="#" class="text-white text-decoration-underline" id="${undoLinkID}">Undo</a>`);
                        const undo = document.querySelector(`#${undoLinkID}`) as HTMLAnchorElement;
                        undo.addEventListener('click', async e => {
                            e.preventDefault();
                            t?.dispose();
                            await taxexemptions.RestoreUserTaxExemption(userTaxExemptions.id || '');
                            pl.Load();
                        });
                        pl.Load();
                    });
            });

            if (!userTaxExemptions.userTaxExemptionUploads?.length) {
                downloadBtn?.remove();
            }

            downloadBtn?.addEventListener('click', async () => {
                if (userTaxExemptions.userTaxExemptionUploads) {
                    const urls: Source[] = [];

                    userTaxExemptions.userTaxExemptionUploads.forEach(el => {
                        const url: Source = {
                            name: el.upload?.name || '',
                            url: `${window.cloudFront}/${el.upload?.key || ''}`,
                        };

                        urls.push(url);
                    });

                    await DownloadURLs(userTaxExemptions.number || '', urls);
                }
            });

            return card;
        },

    });

    parent?.previousElementSibling?.classList.add('d-none');

    pl.Load();
}